// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DotMenuIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DotMenuIcon" ref={forwardedRef} {...props}>
      <path d="M11.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
      <path d="M11.499 15a1.5 1.5 0 1 1-3 .001 1.5 1.5 0 0 1 3 0" />
      <path d="M9.999 11.5a1.5 1.5 0 1 0 0-2.999 1.5 1.5 0 0 0 0 3" />
    </SvgIcon>
  );
});

/**
 * use as a menu in toolbars, as a minimized menu or for more information
 * @public
 */
export const DotMenuIcon = /* @__PURE__ */ Object.assign(DotMenuIconComponent, {
  displayName: 'DotMenuIcon',
});
